import React from 'react'

const OurServices = () => {
    return (
        <div>
            <div className="site-wrap" id="home-section">
                <div
                    style={{
                        backgroundImage:
                            "url(https://pricelessrentalsusa.com/wp-content/uploads/2023/07/mt-1582-home-header-bg-1.jpg)"
                    }}
                >
                
                    <div className="ftco-blocks-cover-1">
                        <div className="ftco-cover-1 overlay innerpage">
                            <div className="container">
                                <div className="row align-items-center justify-content-center">
                                    <div className="col-lg-6 text-center">
                                        <h1>Our Services</h1>
                                        <p>Premium Car Rentals That Elevate Your Journey</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 mb-5 mb-lg-0 order-lg-2">
                                <img
                                    src="https://i.ibb.co/k8LNH7t/Capture.png"
                                    alt="Image"
                                    className="img-fluid"
                                />
                            </div>
                            <div className="col-lg-4 mr-auto">
                                <h2>Chauffeur Car Rentals</h2>
                                <p>
                                    Indulge in luxury and relaxation with our chauffeur-driven car
                                    rental services. Our professional drivers ensure a smooth and
                                    comfortable ride, allowing you to focus on what matters most.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 mb-5 mb-lg-0">
                                <img
                                    src="https://i.ibb.co/cb2HP6s/Capture11.png"
                                    alt="Image"
                                    className="img-fluid"
                                />
                            </div>
                            <div className="col-lg-4 ml-auto">
                                <h2>Delegation Car Rentals</h2>
                                <p>
                                    For group travel or business delegations, our delegation car rental
                                    services offer convenience and efficiency. Trust us to meet your
                                    unique delegation transportation needs..
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <footer className="site-footer ">
                    <div className="container mt-10">
                        <div className="row mt-10">
                            <div className="col-lg-4">
                                <h2 className="footer-heading mb-4">About Us</h2>
                                <p>
                                    At Premium Car Rentals, we take pride in offering specialized
                                    corporate car rental services to meet your every travel need.
                                    Whether you prefer the freedom of self-drive, the luxury of
                                    chauffeur-driven rides, or require a delegation car rental, we have
                                    you covered.
                                </p>
                            </div>
                            <div className="col-lg-8 ml-auto text-center">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <h2 className="footer-heading mb-4">Quick Links</h2>
                                        <ul className="list-unstyled">
                                            <li>
                                                <a className="text-white" href="about.html">
                                                    About Us
                                                </a>
                                            </li>
                                            <li>
                                                <a className="text-white" href="cars.html">
                                                    Our Fleet
                                                </a>
                                            </li>
                                            <li>
                                                <a className="text-white" href="services.html">
                                                    {" "}
                                                    Service
                                                </a>
                                            </li>
                                            <li>
                                                <a className="text-white" href="contact.html">
                                                    Contact Us
                                                </a>
                                            </li>
                                            <li>
                                                <a className="text-white" href="policy.html">
                                                    Our Policy
                                                </a>
                                            </li>
                                            <li>
                                                <a className="text-white" href="Terms&Conditions.html">
                                                    Terms &amp; Conditions
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-lg-6">
                                        <h3 className="">Contact Info</h3>
                                        <ul className="list-unstyled footer-link">
                                            <li className=" mb-3">
                                                <span className="fw-bold text-white">Address: </span>
                                                <span className="text-white">
                                                    {" "}
                                                    Cardinal Rugambwa Social Center, Suit No. 09 Haile Selasie
                                                    Road, Oysterbay, P.O.Box 2340 Dar es Salaam, Tanzania.
                                                </span>
                                            </li>
                                            <li className="mb-3">
                                                <span className="fw-bold text-white">Phone:</span>
                                                <span className="text-white"> +255 757 900007</span>
                                            </li>
                                            <li className=" mb-3">
                                                <span className="fw-bold text-white">Email:</span>
                                                <span className="text-white">
                                                    office@premiumcarrentals.co.tz
                                                </span>
                                            </li>
                                            <li className=" mb-3">
                                                <span className="fw-bold text-white">Website:</span>
                                                <span className="text-white">
                                                    www.premiumcarrantals.co.tz{" "}
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <p className="text-center">
                                For inquiries and bookings, contact us call or WhatsApp at 0757900007.
                            </p>
                        </div>
                        <div className="row pt-5 mt-5 text-center">
                            <div className="col-md-12">
                                <div className="border-top pt-5">
                                    <p>Premium Car Rentals Limited – Elevate Your Travel Experience!</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer> */}
            </div>

        </div>
    )
}

export default OurServices
